import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// External dependencies
import { TextField } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
/** Local styles */
const styles = {
    text: {
        width: '100%',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.03125rem',
        color: '#404943',
    },
    container: {
        padding: '0 0 1.5rem',
    },
};
;
/**
 * Customized TextField
 * @param {any} props
 * @returns {<Box>}
 */
export const TextFieldSG = function (props) {
    const { t } = useTranslation();
    const { hidden, label, helperText } = props;
    let { xstyles } = props;
    if (!xstyles) {
        xstyles = {};
    }
    ;
    return (_jsx(Box, Object.assign({ sx: Object.assign(Object.assign(Object.assign({}, styles.container), xstyles), { display: hidden ? 'none' : 'block' }) }, { children: _jsx(TextField
        // Customized textfield
        , Object.assign({ 
            // Customized textfield
            sx: Object.assign(Object.assign({}, styles.text), { '& .MuiInputBase-root': {
                    backgroundColor: 'white.main',
                } }) }, props, { label: t(label), helperText: helperText ? t(helperText) : false })) })));
};
